import { CompanyWithParentsInterface } from '../api/models/interfaces/CompanyWithParentsInterface';

const getFullCompanyName = (company: CompanyWithParentsInterface): string => {
  let name = company.title;
  if (company.parentId?.title) {
      name = `${name} (${company.parentId?.title}`;
      if (company.parentId?.parentId?.title) {
          name = `${name}, ${company.parentId?.parentId?.title}`;
      }
      name = `${name})`
  }
  return name;
}

export {
  getFullCompanyName
}
